export default __webpack_public_path__ + "static/ThreeQuarter-7fd385498e6f8edaa90929184793a9eb.svg";